import { cva } from 'class-variance-authority';
export const drawerVariants = cva('', {
    variants: {
        position: {
            fixed: 'drawer-fixed',
            absolute: 'drawer-absolute',
        },
        orient: {
            left: 'drawer-left',
            right: 'drawer-right',
        },
        size: {
            large: 'drawer-large',
            medium: 'drawer-medium',
        },
    },
    defaultVariants: {
        position: 'fixed',
        orient: 'right',
        size: 'medium',
    },
});
//# sourceMappingURL=variants.js.map